import styled from 'styled-components';

export const StepsTwoMLStyled = styled.div`
  .set-color-font-wrap {
    .MuiFormControl-root {
      height: 24px;
    }
    .MuiSelect-select {
      height: 24px;
      min-height: 24px;
      line-height: 24px;
      padding: 0 24px 0 0;
    }
  }
  .title-three-tip-icon {
    width: 14px;
    height: 14px;
    color: #9e9e9e;
  }
  .probability-list-wrap .MuiFormControl-root {
    height: 20px;
    .MuiInput-root {
      height: 20px;
      input {
        height: 20px;
        line-height: 1;
        padding: 0;
        text-align: right;
      }
    }
  }
  .input-height-auto {
    .MuiFormControl-root {
      height: auto;
    }
  }
  .checkBox-no-label .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const ModalStyled = styled.div`
  width: ${(props) => (props.type === 'colorSelect' ? 300 : 540)}px;
  padding: 24px 24px;
  .first-line {
    width: 100%;
    display: flex;
    gap: 48px;
    .show-data {
      padding: 0 32px;
      display: flex;
      font-size: 12px;
      color: #212121;
      justify-content: center;
      min-width: 120px;
      align-items: center;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
      border: ${(props) => (props?.keyField ? '1px solid #1565C0' : '')};
      border-radius: 14px;
      background-color: #f9f9f9;
    }
    .MuiFormControl-root {
      width: 270px;
    }

    margin-bottom: 64px;
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .cancel {
      margin-right: 16px;
    }
  }
`;
